import React from "react";
import { useAuth } from "@/context/AuthContext";

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_d5278f1b-cbbc-4815-88a4-f0fa090d0a7c/artifacts/uvhwaq73_ht%20logo.png";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_d5278f1b-cbbc-4815-88a4-f0fa090d0a7c/artifacts/nvo79lkb_ht%20logo%20black.png";

export function Logo({ className = "h-10", ...props }) {
  const { theme } = useAuth();
  const src = theme === "dark" ? LOGO_DARK : LOGO_LIGHT;
  return <img src={src} alt="HighThrone" className={className} data-testid="ht-logo" {...props} />;
}
